import ElementCreator from './abstract/element';

class TableGetter extends ElementCreator {
  initialize () {
    super.initialize();
  }
}

module.exports = TableGetter;
